import axios from 'axios';
import { useAppDispatch } from '../store/store';
import { handleLogOut } from '../store/auth-slice/auth-slice';

const BASE_URL = process.env.REACT_APP_API_URL;
export const axiosInstance = axios.create({
    baseURL: BASE_URL,
});

const axiosHandler = (Wrapper: any) => {
    function AxiosHandler(props: any) {
        const dispatch = useAppDispatch();
    
        axiosInstance.interceptors.response.use(
            function (response) {
                return response;
            },
            function (error) {
                if (error?.response?.status) {
                    switch (error.response.status) {
                        case 401:
                            dispatch(handleLogOut());
                            return;
                        default:
                            break;
                    }
                }

                return Promise.reject(error);
            }
        );
        
        return <Wrapper {...props} />;
    }

    return AxiosHandler;
};
  
export default axiosHandler;
  